(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore.js');
"use strict";

var _svs;

const {
  ReactIntersectionProvider
} = svs.components.lbUtils.intersectionObserver;
const {
  HighscoreList,
  HighscoreProvider,
  HighscoreChoiceButton,
  HighscoreContext
} = svs.components.marketplaceCompetition.routeResult.highscore;
const {
  HighscoreListType
} = svs.components.marketplaceCompetition.services.constants.highscoreConstants;
const {
  useSelector
} = ReactRedux;
const {
  ReactIcon,
  ReactPaper: Paper
} = svs.ui;
const {
  Loader
} = svs.components.ReactLoader;
const {
  RadioGroup,
  ControlGroup
} = svs.ui.reactForm;
const {
  PersonalResults
} = svs.components.marketplaceCompetition.routeResult.personalResults;
const {
  HighscoreSearch
} = svs.components.marketplaceCompetition.routeResult.highscore;
const {
  selectCompetitionResultSearchTerm,
  selectCompetitionResultPending,
  selectCompetitionResult
} = svs.components.marketplaceCompetition.services.selectors.competitionResultSelectors;
const {
  userSession
} = svs.core;
const {
  DisabledTeamResult
} = svs.components.marketplaceCompetition.disabledTeamResult;
const {
  useCompetitionId
} = svs.components.marketplaceCompetition.competitionContext;
const cmsCompetitions = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.cmsData) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 ? void 0 : _svs.competitions;
const {
  useContext,
  useMemo
} = React;
const HighscoreBase = () => {
  const competitionId = useCompetitionId();
  const {
    typeDescription,
    type
  } = useContext(HighscoreContext);
  const searchterm = useSelector(state => selectCompetitionResultSearchTerm(state, type));
  const listIsPending = useSelector(state => selectCompetitionResultPending(state, competitionId, type));
  const list = useSelector(state => selectCompetitionResult(state, competitionId, type, 30));
  const searchDescription = "S\xF6k efter ".concat(typeDescription, "...");
  const ariaLabel = "S\xF6k efter ".concat(typeDescription);
  const individualLoading = listIsPending && type === HighscoreListType.Individual;
  const teamLoading = listIsPending && type === HighscoreListType.Team;
  const shouldRenderSearchbar = useMemo(() => searchterm !== '' || list.length > 0 && searchterm === '', [list.length, searchterm]);
  const isLoggedIn = userSession.hasRole(userSession.roles.PLAYER);
  let isTeamResultDisabled = false;
  if (cmsCompetitions && cmsCompetitions.length) {
    const activeComp = cmsCompetitions.find(comp => comp.competitionId === competitionId);
    if (activeComp) {
      isTeamResultDisabled = activeComp.disable_team_result;
    }
  }
  return React.createElement("div", {
    className: "highscore-container competition-content"
  }, React.createElement("h2", {
    className: "highscore-title f-center f-medium"
  }, "Topplistan"), React.createElement("p", {
    className: "highscore-notice"
  }, React.createElement(ReactIcon, {
    icon: "information",
    size: "100"
  }), ' ', "Listan uppdateras efter varje avslutad omg\xE5ng"), React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(RadioGroup, {
    size: "200"
  }, React.createElement(HighscoreChoiceButton, {
    type: HighscoreListType.Individual
  }, !individualLoading && 'Individuell', individualLoading && React.createElement(Loader, {
    size: 200
  })), React.createElement(HighscoreChoiceButton, {
    type: HighscoreListType.Team
  }, !teamLoading && 'Lag', teamLoading && React.createElement(Loader, {
    size: 200
  })))), type === HighscoreListType.Team && isTeamResultDisabled ? React.createElement(Paper, {
    branding: "sport"
  }, React.createElement(DisabledTeamResult, null)) : React.createElement(React.Fragment, null, isLoggedIn && React.createElement(PersonalResults, {
    showIndividual: type === HighscoreListType.Individual,
    showTeams: type === HighscoreListType.Team
  }), shouldRenderSearchbar && React.createElement(HighscoreSearch, {
    ariaLabel: ariaLabel,
    competitionId: competitionId,
    description: searchDescription,
    searchterm: searchterm
  }), React.createElement(HighscoreList, null)));
};
const Highscore = () => React.createElement(ReactIntersectionProvider, null, React.createElement(HighscoreProvider, null, React.createElement(HighscoreBase, null)));
setGlobal('svs.components.marketplaceCompetition.routeResult.highscore.Highscore', Highscore);

 })(window);